import { Wallet } from "lucide-react";
import { StatCard } from "@/components/cards/StatCard";

interface AccountSummaryCardProps {
  saldoTotal: number;
  loading: boolean;
}

export function AccountSummaryCard({ saldoTotal, loading }: AccountSummaryCardProps) {
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  };

  const formattedValue = loading
    ? "Carregando..."
    : formatCurrency(saldoTotal);

  return (
    <StatCard
      title="Saldo Total das Contas"
      value={formattedValue}
      icon={Wallet}
      variant="balance"
    />
  );
}